import {Component, OnInit} from '@angular/core';
import {View} from "./interfaces/view.interface";
import {NavParams} from "ionic-angular";

@Component({
  selector: 'sellions-layout-renderer-tabs',
  templateUrl: './tabs.component.html',
})
export class TabsComponent implements OnInit {
  private tabs: View[] = [];
  private tabsPlacement: string = "top";

  constructor(private navParams: NavParams) {
  }

  public ngOnInit() {
    if (this.tabs.length == 0) {
      throw new Error('No tabs provided!');
    }
  }
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_layout_renderer/projects/sellions-layout-renderer-lib/src/lib/components/tabs/tabs.component.ts